import React from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorFallbackProps {
    error: Error | null;
    /** בתוך הפריסה (ר' Layout) הכרטיסייה ממלאת את אזור התוכן, לא את כל המסך. */
    inline?: boolean;
}

/*
 * HAT-1343: הכפתור הזה היה קורא ל-resetErrorBoundary() של react-error-boundary.
 * reset רק מנקה את דגל השגיאה ומרנדר מחדש **בדיוק את אותו עץ**, באותו route,
 * מול אותו QueryClient שחי בזיכרון - ולכן כשמקור השגיאה הוא ערך שנתקע ב-cache
 * (ר' assertJsonBody ב-ApiCalls) הקומפוננטה קורסת שוב באותו render. המדווח לחץ
 * שמונה פעמים ברצף וקיבל את אותו מסך; זו היתה התלונה.
 *
 * טעינה מלאה של הדף היא הפעולה היחידה שמנקה את ה-cache שבזיכרון, והיא גם מה
 * שהכיתוב מבטיח. "חזרה לעמוד הבית" היא מוצא נוסף לשגיאה שחוזרת על עצמה בנתיב
 * מסוים גם אחרי טעינה - שם reload לבדו היה מחזיר את המשתמש לאותו מסך שבור.
 */
const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, inline }) => {
    const { t } = useTranslation();

    return (
        // TODO: change to the desired design
        <div className={`flex items-center justify-center bg-gray-50 ${inline ? 'min-h-[50vh]' : 'min-h-screen'}`}>
            <div className="bg-white p-6 rounded shadow-md max-w-md text-center">
                <h2 className="body-md-bold text-(--font-primary)">
                    {t('errorBoundary.title')}
                </h2>
                <p className="mb-4 text-gray-600">
                    {t('errorBoundary.message')}
                </p>
                <p className="mb-4 text-sm text-gray-500 break-words">
                    {error?.message}
                </p>
                <div className="flex items-center justify-center gap-2 flex-wrap">
                    <button
                        onClick={() => window.location.reload()}
                        className="text-(--font-primary) bg-gray-100 px-4 py-2 rounded"
                    >
                        {t('errorBoundary.reload')}
                    </button>
                    <button
                        onClick={() => window.location.assign('/new/')}
                        className="text-(--font-primary) px-4 py-2 rounded underline"
                    >
                        {t('errorBoundary.goHome')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
